import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    dialog: {
      '& .MuiDialog-paperWidthSm': {
        maxWidth: '408px',
      },
      '& .MuiDialogTitle-root': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',

        '& .MuiTypography-h3': {
          color: theme.palette.primary.dark,
          fontSize: '2.2rem',
          marginTop: '1rem',
        },
        '& img': {
          height: '22rem',
        },
      },
      '& .MuiDialogContent-root': {
        display: 'flex',
        flexDirection: 'column',
        gap: '1.6rem',
        '& .MuiTypography-subtitle2': {
          fontSize: '1.6rem',
        },
      },
      '& .MuiFormControlLabel-root': {
        margin: 0,
        display: 'flex',
        '& .MuiTypography-body1': {
          fontSize: '1.2rem',
          flex: 1,
        },
        '& .MuiCheckbox-root': {
          marginLeft: '-0.8rem',
        },

        '& svg': {
          width: '1.6rem',
          height: '1.6rem',
        },
      },
      '& .MuiDialogActions-root': {
        '& button': {
          margin: '0 1.6rem 1.6rem 1.6rem',
        },
      },
    },
    select: {
      color: theme.palette.secondary.main,

      '& .MuiOutlinedInput-input': {
        paddingTop: theme.spacing(1.6),
        paddingBottom: theme.spacing(1.6),
      },

      '&:not(.Mui-error), Mui-focused': {
        '&.success .MuiOutlinedInput-notchedOutline': {
          borderColor: `${theme.palette.primary.light}`,
        },

        '&:hover.MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-notchedOutline':
          {
            borderColor: `${theme.palette.secondary.light}`,
          },
      },

      '&.Mui-error.Mui-focused': {
        '&:hover.MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-notchedOutline':
          {
            borderColor: `${theme.palette.error.main}`,
          },
      },
    },
    label: {
      background: `${theme.palette.background.paper}`,
    },
    paper: {
      maxWidth: '300px',
      '& .MuiCheckbox-root': {
        color: '#727970',
      },
      '& .MuiCheckbox-root.Mui-checked': {
        color: theme.palette.primary.dark,
      },
      '& .MuiMenuItem-root': {
        whiteSpace: 'normal',
        '& .MuiButtonBase-root': {
          padding: '0 1.6rem 0 0',
        },
      },
      '& .MuiTypography-body1': {
        fontSize: '1.4rem',
      },
    },
    tooltip: {
      backgroundColor: '#505356',
      color: '#FFFFFF',

      maxWidth: '30rem',
      fontSize: '1rem',
      padding: theme.spacing(1),

      border: 'none',
      borderRadius: 5,
    },
    loadingSelect: {
      width: '6rem',
    },
  }),
)
